var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { utilQuickSkip } from "../../utils/utilQuickSkip";
import { utilSkipProcess } from "../../utils/utilSkipProcess";
import { utilTime } from "../../utils/utilTime";
import { IdQuickSkip } from "./IdQuickSkip";
import { QuickSkipDialogWrapper } from "./QuickSkipDialogWrapper";
export var QuickSkipProduction = function (_a) {
    var onSkip = _a.onSkip, building = _a.building, onCancel = _a.onCancel, skipProcessFactor = _a.skipProcessFactor, processTotalTime = _a.processTotalTime, icon = _a.icon;
    if (building == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var remainingTime = utilQuickSkip.getProcessRemainingTimestamp(building, IdQuickSkip.Production);
    var timeLeft = utilTime.secondsLeftTill(remainingTime);
    var skipCost = utilSkipProcess.calculateCostToSkipProcess(timeLeft, skipProcessFactor);
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(skipCost)]]);
    var quickSkipDialogWrapperProps = {
        description1: IdLoca.quickSkipDialog_prod_desc1,
        description2: IdLoca.quickSkipDialog_prod_desc2,
        icon: icon,
        locaReplacements: locaReplacements,
        onCancel: onCancel,
        onSkip: function () { return onSkip(building); },
        processTotalTime: processTotalTime,
        remainingTime: remainingTime,
        skipProcessFactor: skipProcessFactor,
        title: IdLoca.quickSkipDialog_prod_title,
    };
    return React.createElement(QuickSkipDialogWrapper, __assign({}, quickSkipDialogWrapperProps));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/QuickSkipProduction.tsx
// module id = 2893
// module chunks = 3